<template>
    <v-dialog v-model="dialog" persistent :max-width="width"
              :fullscreen="$vuetify.breakpoint[breakpoint]"> <!---->
        <v-card flat v-show="!loader" >
            <v-card-title>
                <v-icon v-if="headerIcon" class="mr-3">{{headerIcon}}</v-icon>
                <span class="heebo fw600">{{headerText}}</span>
                <v-spacer></v-spacer>
            <!-- realtime save info -->
                <div v-if="$vuetify.breakpoint.mdAndUp">
                    <v-chip v-if="realtimeSave && !saved" class="ma-2 pr-5" color="grey" dark>
                        <v-icon left class="ml-1">mdi-information-outline</v-icon>
                        Änderungen werden laufend automatisch gespeichert
                    </v-chip>
                    <v-chip v-if="saved" class="ma-2 pr-5" color="success" dark>
                        <v-icon left class="ml-1" small>mdi-check</v-icon>
                        Änderungen wurden gespeichert
                    </v-chip>
                </div>
            <!-- close -->
                <v-btn icon @click="close()"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-card-subtitle v-if="$vuetify.breakpoint.smAndDown">
                <v-chip v-if="realtimeSave && !saved" class="mt-2 pr-5" color="grey" dark>
                    Änderungen werden automatisch gespeichert
                </v-chip>
                <v-chip v-if="saved" class="mt-2 pr-5" color="success" dark>
                    <v-icon left class="ml-1" small>mdi-check</v-icon>
                    Änderungen wurden gespeichert
                </v-chip>
            </v-card-subtitle>
            <v-card-subtitle v-if="headerSubText" class="pb-1">{{headerSubText}}</v-card-subtitle>
            <v-card-subtitle v-if="headerSubText2" class="pb-0">{{headerSubText2}}</v-card-subtitle>
            <div v-if="!waiting" class="mt-3">
                <v-card-text class="pa-0">
                    <v-form ref="form" lazy-validation v-if="rules" @submit.prevent>
                        <slot></slot>
                    </v-form>
                </v-card-text>
                <v-alert v-if="showAlert" dense style="margin: auto" type="error" class="my-1 mx-5">
                    Bitte alle rot markieren Felder füllen.</v-alert>
                <v-card-actions class="pb-4 px-5" v-if="!hideActions">
                    <v-btn v-if="buttonCancel" text @click="close()">{{buttonCancel}}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn v-if="buttonOk" text :color="buttonOkColor" @click="save('save')" class="mr-3">{{buttonOk}}</v-btn>
                    <v-btn v-if="buttonOkSecond" text :color="buttonOkSecondColor" @click="save('saveSecond')">{{buttonOkSecond}}</v-btn>
                </v-card-actions>
            </div>
            <v-card-text class="pa-5 text-center" v-else>
                <v-progress-circular indeterminate color="primary" class="mb-5"></v-progress-circular>
            </v-card-text>
            </v-card>
    </v-dialog>
</template>

<script>
    import {FormRules} from "../../services/formRules";

    export default {
        name: "form-container",
        data: () => ({
            rules: null,
            dialog: false,
            showAlert: false,
        }),
        props: {
            hideActions: {default: false},
            breakpoint: {default: 'xsOnly'},
            headerText: {default: ''},
            headerSubText: {default: ''},
            headerSubText2: {default: ''},
            headerIcon: {default: ''},
            useRoute: {default: true},
            action: {default: ''},
            validActions: {default: []},
            width: {default: 450},
            buttonOk: {default: 'Speichern'},
            buttonCancel: {default: 'Abbrechen'},
            buttonOkColor: {default: 'primary'},
            waiting: {default: false},
            buttonOkSecond: {default: ''},
            buttonOkSecondColor: {default: 'primary'},
            realtimeSave: {default: false},
            saved: {default: false},
            missingInputAlert: {default: false},
            noHistoryBackSpecial: {default: false},
        },
        computed: {
            loader(){return this.$store.state.local.loader; },
        },
        created(){
            this.rules = new FormRules();
            this.open();
        },
        methods: {
            save(type){
                if ( this.$refs.form.validate() ) { // form incomplete
                    this.showAlert = false;
                    this.$emit(type);
                } else if (this.missingInputAlert) {
                    this.showAlert = true;
                    setTimeout(()=>{this.showAlert = false;}, 4000)
                }
            },
            close(){
                if ( this.useRoute ) {
                    if (document.referrer == "" && this.noHistoryBackSpecial ) {
                        this.$emit('noHistoryBack');
                    } else {
                        window.history.back();
                    }
                } else {
                    this.$emit('close');
                }
            },
            open(){
                this.dialog = this.validActions.indexOf(this.$route.query.action) !== -1;
            }
        },
        watch: {
            '$route.query.action'(){
                if ( this.validActions.indexOf(this.$route.query.action) === -1 && this.$refs.form ) {
                    //console.log ("RESET !!!!!!!!!!!");
                    //this.$refs.form.resetValidation();
                }
                this.open();
            },
        }
    }
</script>

<style scoped>
</style>